import React from 'react';
interface FlipCardProps {
  flipped: boolean;
  onToggle: () => void;
  label: string;
  /** Height utility for the card, e.g. "h-[620px]" */
  heightClassName?: string;
  /**
   * Increment to spin the card a full turn without changing the visible face.
   * Used when the card's content changes underneath the user.
   */
  spin?: number;
  children: {
    front: React.ReactNode;
    back: React.ReactNode;
  };
}

/**
 * A card that flips on click to reveal a second face. Clicks that land on a
 * nested control (button, link, input) are ignored so those stay usable.
 */
export function FlipCard({
  flipped,
  onToggle,
  label,
  heightClassName = 'h-[620px] lg:h-[min(720px,calc(100vh-16rem))]',
  spin = 0,
  children
}: FlipCardProps) {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).closest('button, a, input')) {
      return;
    }
    onToggle();
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle();
    }
  };
  return <div role="button" tabIndex={0} aria-pressed={flipped} aria-label={`${label}. ${flipped ? 'Showing pricing' : 'Click to show pricing'}.`} onClick={handleClick} onKeyDown={handleKeyDown} className={`relative w-full cursor-pointer [perspective:1600px] rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3] ${heightClassName}`} data-id="element-196" data-mp="1u9evfupw7mes">
      <div className="relative h-full w-full transition-transform [transform-style:preserve-3d]" style={{
      transitionDuration: '390ms',
      transform: `rotateY(${(flipped ? 180 : 0) + spin * 360}deg)`,
      transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
    }} data-id="element-197" data-mp="2czwawxlpsli7">
        <div aria-hidden={flipped} className="absolute inset-0 [backface-visibility:hidden] overflow-y-auto" data-id="element-198" data-mp="wkv13lhlafet">
          {children.front}
        </div>
        <div aria-hidden={!flipped} className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] overflow-y-auto" data-id="element-199" data-mp="132ogicrgq54d">
          {children.back}
        </div>
      </div>
    </div>;
}